// extracted by mini-css-extract-plugin
export default {"dropdownEllipsisInput":"styles_dropdownEllipsisInput__+qNIf","requiredMark":"styles_requiredMark__vJY-t","requiredLabel":"styles_requiredLabel__G7o-Z"};